import {useLazyQuery} from "@apollo/client";
import DOMPurify from "dompurify";
import {useEffect} from "react";
import {FiLoader} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {GQL_MARKDOWN_RENDER} from "@/lib/queries/common.ts";
import {MarkdownResult} from "@/lib/types/common.ts";

import styles from "./AnalyzerMarkdown.module.scss";

interface AnalyzerMarkdownProps {
  content: string;
}

export const AnalyzerMarkdown = ({content}: AnalyzerMarkdownProps) => {
  const [renderMarkdown, {data, error}] = useLazyQuery<MarkdownResult>(GQL_MARKDOWN_RENDER);

  useEffect(() => {
    renderMarkdown({variables: {markdown: content}});
  }, [content, renderMarkdown]);

  const html = data?.renderMarkdown.data;

  if (html) {
    return <div className={styles.contentEvent} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(html)}} />;
  }
  if (error) {
    return <div className={styles.contentEvent}>{content}</div>;
  }
  return <Icon icon={FiLoader} size="tiny" className="pulseSpin text-muted" />;
};
